module.exports = __webpack_public_path__ + "img/bottomTitle.a6128458.svg";